import React from 'react';
import MemberHeader from './sections/MemberHeader';
import FanInfoPanel from './sections/FanInfoPanel';
import SubscriptionStats from './sections/SubscriptionStats';
import InvoiceHistory from './sections/InvoiceHistory';
import ActivityTimeline from './sections/ActivityTimeline';
import GiftPanel from './sections/GiftPanel';
import '../../TeamManager/styles/teamManagerStyles.css';

export default function MembershipShow() {
  return (
    <div className="membership-show container-fluid pt-3">
      <MemberHeader />
      <GiftPanel />
      <div className="row">
        <div className="col-md-6 mb-3"><FanInfoPanel /></div>
        <div className="col-md-6 mb-3"><SubscriptionStats /></div>
      </div>
      <InvoiceHistory />
      <ActivityTimeline />
    </div>
  );
}

MembershipShow.propTypes = {};
